(function ($) {
    'use strict';

    /**
     * Плагин яндекс-карты и блока справа.
     * Принимает данные о кассах и генерирует метки на карте и текстовом блоке
     * @param {array} [arrayPlacesTicket] - данные о кассах
     * @param {string} arrayPlacesTicket[0].id - Индефикатор кассы
     * @param {string} arrayPlacesTicket[0].type - Тип кассы
     * @param {array} arrayPlacesTicket[0].coords - Массив кординат
     * @param {string} arrayPlacesTicket[0].time - Время работы кассы
     * @param {string} arrayPlacesTicket[0].timeTerminals - Время работы терминала
     * @param {string} arrayPlacesTicket[0].tel - Телефон кассы
     * @param {string} arrayPlacesTicket[0].address - адресс кассы
     * @return {JQuery}
     */

    $.fn.renderTicketsMap = function (arrayPlacesTicket) {
        const $self = $(this);
        const $locationList = $self.find('.js-location-list');
        const $tabletFilter = $self.find('.js-custom-select');
        const $tabletFilterButton = $tabletFilter.find('.js-filter-button');
        const $switchButton = $self.find('.js-switch-button').find('button');
        const mapContainer = $self.find('.js-map');
        const rightContainer = $self.find('.js-right-block');
        const $desktopFilter = $self.find('.js-desktop-filter');

        let mapObject;
        let placeList = arrayPlacesTicket;

        ymaps.ready(function () {
            mapObject = new ymaps.Map(
                'YMapsID',
                {
                    center: [53.38815325, 58.98356143],
                    zoom: 13,
                    behaviors: ['default', 'scrollZoom'],
                    controls: [],
                },
                {
                    autoFitToViewport: 'always',
                }
            );

            /**
             *Принимает метку на карте и возвращает его дом воплащение.
             *@param {object} mark - метка в виде объекта
             *@return {HTMLnode} - возвращает HTML элемент метки
             */
            const getMarkDom = (mark) =>
                mark.getOverlaySync().getLayoutSync().getElement();
            /**
             * Ищет нужную метку на карте в геообъектах mapObject
             *@param {string} id - индефекатор метки, сохранёный в поле properties.id у метки
             *@return {object} Возвращает объект метки
             */
            const searchMarkOnMap = (id) => {
                let geoObject = ymaps.geoQuery(mapObject.geoObjects);
                geoObject = geoObject.search('properties.id = ' + id);

                return geoObject.get(0);
            };

            /**
             *Связывает метку на карте и в блоке справа и добавляет поведение по ховеру
             *@param {string} id - индефекатор метки и блока справа.
             */
            const focusPlaces = (id) => {
                let mark = searchMarkOnMap(id);
                let markDom = getMarkDom(mark);
                mapObject.setCenter(mark.geometry.getBounds()[0], mapObject.getZoom(), {
                    duration: 300,
                });
                setHover(markDom, id);
            };

            /**
             *Убирает поведение по ховеру у метки и блока справа
             *@param {string} id - индефекатор метки и блока справа.
             */
            const blurPlaces = (id) => {
                let mark = searchMarkOnMap(id);
                mark = getMarkDom(mark);
                deleteHover(mark, id);
            };

            /**
             *Устанавливает класс hover - выбранным node-element
             *@param {string} dom-node метки на карте
             *@param {string} id - по которой ищется dom-node блока справа.
             */
            const setHover = (markDom, id) => {
                $(markDom).find('.js-pin').addClass('hover');
                $locationList.find('#' + id).addClass('hover');
            };

            /**
             *Удаляет класс hover - выбранным node-element
             *@param {string} dom-node метки на карте
             *@param {string} id - по которой ищется dom-node блока справа.
             */
            const deleteHover = (markDom, id) => {
                $(markDom).find('.js-pin').removeClass('hover');
                $locationList.find('#' + id).removeClass('hover');
            };

            /**
             *Скролит блок справа к выбранной метке на карте.
             *@param {string} itemId - блока справа
             */
            const scrollToPlace = (itemId) => {
                let scrollTop =
                    $locationList.find('.js-location-place:first-child').offset().top - $locationList.offset().top;
                let targetTop =
                    $locationList.find('#' + itemId).offset().top - $locationList.offset().top;
                let scrollOffset = targetTop - scrollTop - 10;
                $locationList.animate({ scrollTop: scrollOffset }, 'slow');
            };

            /**
             *Добавляет количество включенных фильтров(mobile\tablet)
             */
            const getNumberFilter = () => {
                let $selectBtn = $tabletFilter.find('.js-select-btn');
                let numberFilter = $tabletFilter.find('input[type="checkbox"]:checked').length;

                if (numberFilter !== 0) {
                    $selectBtn.find('span').text(' (' + numberFilter + ')');
                } else {
                    $selectBtn.find('span').text('');
                }
            };

            /**
             *Показывает карту либо список на table/mobile
             */
            const setSwitchActive = () => {
                let $mapButton = $self.find('.js-view-map');
                let $listenButton = $self.find('.js-view-listen');

                if ($mapButton.hasClass('active')) {
                    $(rightContainer).addClass('visually-hidden');
                    $(mapContainer).removeClass('visually-hidden');
                    $mapButton.removeClass('active');
                    $listenButton.addClass('active');
                } else if ($listenButton.hasClass('active')) {
                    $(rightContainer).removeClass('visually-hidden');
                    $(mapContainer).addClass('visually-hidden');
                    $listenButton.removeClass('active');
                    $mapButton.addClass('active');
                }

                setFilterPlaces(placeList);
            };

            /**
             *Отрендерить информацию о кассах в текстовом блоке
             *@param {array} placesTicket - массив объектов с иходными данными
             */
            const renderPlacesList = (placesTicket) => {
                /**
                 *Выдаёт класс для цвета пина
                 *@param {string} type - тип кассы
                 *@return {string}
                 */
                const getColorPin = (type) => {
                    let colorClass = 'tickets-sale__location-pin';

                    switch (type) {
                        case 'terminals':
                            return colorClass + '--terminals';
                        case 'agents':
                            return colorClass + '--agents';
                        case 'ticketsOffices':
                            return colorClass + '--ticketsOffices';
                    }
                };

                if (placesTicket.length) {
                    placesTicket.forEach(function (element, index) {
                        let $currentElement;

                        $locationList.append(
                            $('<li>', {
                                class:
                                    'tickets-sale__location-item js-location-place',
                                id: element.id,
                                append: [
                                    $('<div>', {
                                        class:
                                            'right-pin tickets-sale__location-pin ' +
                                            getColorPin(element.type),
                                        append: [
                                            $('<span>', {
                                                text: element.numberPlace,
                                            }),
                                        ],
                                    }),
                                    $('<div>', {
                                        class:
                                            'tickets-sale__location-item-inner',
                                        append: [
                                            $('<p>', {
                                                class:
                                                    'tickets-sale__location-contact',
                                                append: [
                                                    $('<span>', {
                                                        class:
                                                            'tickets-sale__location-adress',
                                                        html: element.address,
                                                    }),
                                                    $('<a>', {
                                                        class:
                                                            'tickets-sale__location-tel',
                                                        href:
                                                            'tel:' +
                                                            element.tel,
                                                        text: element.phone,
                                                    }),
                                                ],
                                            }),
                                            $('<p>', {
                                                class:
                                                    'tickets-sale__location-time',
                                                append: [
                                                    $('<span>', {
                                                        html: element.time,
                                                    }),
                                                    $('<span>', {
                                                        html:
                                                            element.timeTerminals,
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            })
                        );
                        if (window.innerWidth >= SVK.breakpoint["desktop-min"]) {
                            $currentElement = $locationList.find(
                                '#' + element.id
                            );
                            $currentElement.on('mouseenter', function () {
                                focusPlaces(this.id);
                            });
                            $currentElement.on('mouseleave', function () {
                                blurPlaces(this.id);
                            });
                        }
                    });
                }
            };

            //Задаём кастомные изображение метки в зависимости от типа кассы.
            let customMapPin = ymaps.templateLayoutFactory.createClass(
                '<div class="tickets-sale__location-pin tickets-sale__location-pin--{{properties.type}} js-pin"><span>{{properties.numberPin}}</span></div>',
                {
                    getShape: function () {
                        let elem = this.getElement();
                        if (!elem) {
                            return null;
                        }
                        let icon = elem.firstChild;

                        return new ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [icon.offsetLeft, icon.offsetTop],
                                [
                                    icon.offsetLeft + icon.offsetWidth,
                                    icon.offsetTop + icon.offsetHeight + 10,
                                ],
                            ])
                        );
                    },
                }
            );

            /**
             *Задает кастомный баллун
             */
            let customBallon = ymaps.templateLayoutFactory.createClass(
                '<div class="ballon">' +
                    '$[[options.contentLayout]]' +
                    '</div>',
                {
                    build: function () {
                        this.constructor.superclass.build.call(this);

                        this._$element = $('.ballon', this.getParentElement());
                    },
                    clear: function () {
                        this.constructor.superclass.clear.call(this);
                    },
                    onSublayoutSizeChange: function () {
                        customBallon.superclass.onSublayoutSizeChange.apply(
                            this,
                            arguments
                        );

                        if (!this._isElement(this._$element)) {
                            return;
                        }

                        this.events.fire('shapechange');
                    },
                    onCloseClick: function (e) {
                        e.preventDefault();
                        this.events.fire('userclose');
                    },
                }
            );

            /**
             *Задаёт кастомную внутренню сетку балуна
             */
            let customBallonContent = ymaps.templateLayoutFactory.createClass(
                '<div class="ballon-item">$[properties.address]</div>' +
                    '<a class="ballon-item" href="tel:$[properties.tel]">$[properties.phone]</a>' +
                    '<span class="ballon-item ballon-item--gray">$[properties.time]</span>' +
                    '<span class="ballon-item ballon-item--gray">$[properties.timeTerminals]</span>'
            );

            /**
             *Фильтрует исходный массив и перерисовывает метки на карте\правый блок
             *@param {array} placeTicket исходный массив объектов
             */
            const setFilterPlaces = (placesTicket) => {
                let filterArray = [];
                let widthWindow = $(window).width();
                let filterChecked =
                    widthWindow >= SVK.breakpoint["desktop-min"]
                        ? $desktopFilter.find('input[type="checkbox"]:checked')
                        : $tabletFilter.find('input[type="checkbox"]:checked');
                filterChecked = filterChecked
                    .map(function () {
                        return this.value;
                    })
                    .get();

                filterArray = placesTicket.filter(function (item) {
                    return filterChecked.indexOf(item.type) !== -1;
                });

                $locationList.empty();
                mapObject.geoObjects.removeAll();

                if (widthWindow >= SVK.breakpoint["desktop-min"]) {
                    renderPlacesMap(filterArray);
                    renderPlacesList(filterArray);
                } else if (rightContainer.hasClass('visually-hidden')) {
                    renderPlacesMap(filterArray);
                } else {
                    renderPlacesList(filterArray);
                }

                if (typeof $locationList.data('ps') !== 'undefined') {
                    $locationList.data('ps').update();
                }
            };

            /**
             *Рендерит метки на карте
             *@param {array} placesTicket массив объектов, данных о кассах
             */
            const renderPlacesMap = (placesTicket) => {
                placesTicket.forEach(function (element) {
                    let placeMark = new ymaps.GeoObject(
                        {
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    element.coords[0],
                                    element.coords[1],
                                ],
                            },
                            properties: {
                                numberPin: element.numberPlace,
                                id: element.id,
                                address: element.address,
                                phone: element.phone,
                                tel: element.tel,
                                time: element.time,
                                timeTerminals: element.timeTerminals,
                                type: element.type,
                            },
                        },
                        {
                            hideIconOnBalloonOpen: false,
                            balloonShadow: false,
                            balloonOffset: [-32, 0],
                            iconLayout: customMapPin,
                            iconOffset: [-16, -40],
                            balloonContentLayout: customBallonContent,
                            balloonLayout: customBallon,
                            balloonPanelMaxMapArea: 1,
                            pointOverlay: 'html#placemark',
                        }
                    );
                    mapObject.geoObjects.add(placeMark);
                    placeMark.events.add('mouseenter', function (e) {
                        let mark = e.get('target');
                        let idMark = mark.properties.get('id');
                        let markDom = getMarkDom(mark);
                        setHover(markDom, idMark);
                        if (window.innerWidth >= SVK.breakpoint["desktop-min"]) {
                            scrollToPlace(idMark);
                        }
                    });

                    placeMark.events.add('mouseleave', function (e) {
                        let mark = e.get('target');
                        let idMark = mark.properties.get('id');
                        let markDom = getMarkDom(mark);
                        deleteHover(markDom, idMark);
                    });

                    placeMark.events.add('balloonopen', function () {
                        let position = placeMark.balloon.getPosition();
                        mapObject.setGlobalPixelCenter([position[0], position[1] + 100], mapObject.getZoom(), {
                            duration: 300
                        });
                    });
                });

                if (placesTicket.length > 0) {
                    mapObject.setBounds(mapObject.geoObjects.getBounds(), {
                        checkZoomRange: true,
                        zoomMargin: 100
                    });
                };
            };

            /**
             *Инициализация глобальных событий
             */

            const initEvents = () => {
                let windowWidth = window.innerWidth;
                $desktopFilter.find('.js-filter').each(function () {
                    this.addEventListener('click', function () {
                        setFilterPlaces(placeList);
                    });
                });

                mapObject.events.add('click', function (e) {
                    mapObject.balloon.close();
                });

                $tabletFilterButton.on('click', function () {
                    setFilterPlaces(placeList);
                    getNumberFilter();
                });

                $(window).on('resize orientationchange', function () {
                    let newWindowWidth = window.innerWidth;
                    if (
                        windowWidth >= SVK.breakpoint["desktop-min"] &&
                        newWindowWidth < SVK.breakpoint["desktop-min"]
                    ) {
                        $(rightContainer).addClass('visually-hidden');
                        setFilterPlaces(placeList);
                    } else if (
                        windowWidth < SVK.breakpoint["desktop-min"] &&
                        newWindowWidth >= SVK.breakpoint["desktop-min"]
                    ) {
                        $(rightContainer).removeClass('visually-hidden');
                        $(mapContainer).removeClass('visually-hidden');
                        setFilterPlaces(placeList);
                    }
                    windowWidth = newWindowWidth;
                });

                $switchButton.each(function () {
                    this.addEventListener('click', function () {
                        setSwitchActive();
                    });
                });
            };

            /**
             *Инициализация плагина
             */
            const init = () => {
                let windowWidth = window.innerWidth;

                if (windowWidth >= SVK.breakpoint["desktop-min"]) {
                    $(rightContainer).removeClass('visually-hidden');
                    $(mapContainer).removeClass('visually-hidden');
                } else {
                    $(rightContainer).addClass('visually-hidden');
                    $(mapContainer).removeClass('visually-hidden');
                }

                placeList.forEach( function (el, index) {
                    el.numberPlace = (index + 1) + '';
                });

                getNumberFilter();
                setFilterPlaces(placeList);
                initEvents();
            };

            init();
        });

        return this;
    };
})(jQuery);
